/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum ConfluenceGroupManagementType {
  ADMINS = "ADMINS",
  EXTERNAL = "EXTERNAL",
  OPEN = "OPEN",
  TEAM_MEMBERS = "TEAM_MEMBERS",
}

export enum ConfluenceGroupUsageType {
  ADMIN_OVERSIGHT = "ADMIN_OVERSIGHT",
  TEAM_COLLABORATION = "TEAM_COLLABORATION",
  USERBASE_GROUP = "USERBASE_GROUP",
}

export enum PrincipalFilterType {
  APP = "APP",
  GROUP = "GROUP",
  GUEST = "GUEST",
  USER = "USER",
  USER_CLASS = "USER_CLASS",
}

export enum SpaceRoleType {
  CUSTOM = "CUSTOM",
  SYSTEM = "SYSTEM",
}

//==============================================================
// END Enums and Input Objects
//==============================================================

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: SpaceRoleAssignmentsByCriteriaQuery
// ====================================================

export interface SpaceRoleAssignmentsByCriteriaQuery_spaceRoleAssignmentsByCriteria_nodes_principal_SpaceRoleAccessClassPrincipal {
  __typename: "SpaceRoleAccessClassPrincipal" | "ConfluenceSpaceRoleAppPrincipal";
  principalId: string;
  displayName: string;
}

export interface SpaceRoleAssignmentsByCriteriaQuery_spaceRoleAssignmentsByCriteria_nodes_principal_SpaceRoleUserPrincipal_profilePicture {
  path: string;
}

export interface SpaceRoleAssignmentsByCriteriaQuery_spaceRoleAssignmentsByCriteria_nodes_principal_SpaceRoleUserPrincipal {
  __typename: "SpaceRoleUserPrincipal";
  principalId: string;
  displayName: string;
  email: string | null;
  profilePicture: SpaceRoleAssignmentsByCriteriaQuery_spaceRoleAssignmentsByCriteria_nodes_principal_SpaceRoleUserPrincipal_profilePicture | null;
}

export interface SpaceRoleAssignmentsByCriteriaQuery_spaceRoleAssignmentsByCriteria_nodes_principal_SpaceRoleGuestPrincipal_profilePicture {
  path: string;
}

export interface SpaceRoleAssignmentsByCriteriaQuery_spaceRoleAssignmentsByCriteria_nodes_principal_SpaceRoleGuestPrincipal {
  __typename: "SpaceRoleGuestPrincipal";
  principalId: string;
  displayName: string;
  email: string | null;
  profilePicture: SpaceRoleAssignmentsByCriteriaQuery_spaceRoleAssignmentsByCriteria_nodes_principal_SpaceRoleGuestPrincipal_profilePicture | null;
}

export interface SpaceRoleAssignmentsByCriteriaQuery_spaceRoleAssignmentsByCriteria_nodes_principal_SpaceRoleGroupPrincipal {
  __typename: "SpaceRoleGroupPrincipal";
  principalId: string;
  displayName: string;
  usageType: ConfluenceGroupUsageType | null;
  managedBy: ConfluenceGroupManagementType | null;
  resourceAri: string | null;
}

export type SpaceRoleAssignmentsByCriteriaQuery_spaceRoleAssignmentsByCriteria_nodes_principal = SpaceRoleAssignmentsByCriteriaQuery_spaceRoleAssignmentsByCriteria_nodes_principal_SpaceRoleAccessClassPrincipal | SpaceRoleAssignmentsByCriteriaQuery_spaceRoleAssignmentsByCriteria_nodes_principal_SpaceRoleUserPrincipal | SpaceRoleAssignmentsByCriteriaQuery_spaceRoleAssignmentsByCriteria_nodes_principal_SpaceRoleGuestPrincipal | SpaceRoleAssignmentsByCriteriaQuery_spaceRoleAssignmentsByCriteria_nodes_principal_SpaceRoleGroupPrincipal;

export interface SpaceRoleAssignmentsByCriteriaQuery_spaceRoleAssignmentsByCriteria_nodes_role_spacePermissionList {
  id: string;
}

export interface SpaceRoleAssignmentsByCriteriaQuery_spaceRoleAssignmentsByCriteria_nodes_role {
  roleId: string;
  roleDisplayName: string;
  roleDescription: string;
  roleType: SpaceRoleType;
  spacePermissionList: SpaceRoleAssignmentsByCriteriaQuery_spaceRoleAssignmentsByCriteria_nodes_role_spacePermissionList[];
}

export interface SpaceRoleAssignmentsByCriteriaQuery_spaceRoleAssignmentsByCriteria_nodes_permissions {
  id: string;
}

export interface SpaceRoleAssignmentsByCriteriaQuery_spaceRoleAssignmentsByCriteria_nodes {
  principal: SpaceRoleAssignmentsByCriteriaQuery_spaceRoleAssignmentsByCriteria_nodes_principal;
  role: SpaceRoleAssignmentsByCriteriaQuery_spaceRoleAssignmentsByCriteria_nodes_role | null;
  permissions: SpaceRoleAssignmentsByCriteriaQuery_spaceRoleAssignmentsByCriteria_nodes_permissions[] | null;
  assignablePermissions: (string | null)[] | null;
}

export interface SpaceRoleAssignmentsByCriteriaQuery_spaceRoleAssignmentsByCriteria_pageInfo {
  endCursor: string | null;
  hasNextPage: boolean;
}

export interface SpaceRoleAssignmentsByCriteriaQuery_spaceRoleAssignmentsByCriteria {
  nodes: SpaceRoleAssignmentsByCriteriaQuery_spaceRoleAssignmentsByCriteria_nodes[] | null;
  pageInfo: SpaceRoleAssignmentsByCriteriaQuery_spaceRoleAssignmentsByCriteria_pageInfo;
}

export interface SpaceRoleAssignmentsByCriteriaQuery {
  spaceRoleAssignmentsByCriteria: SpaceRoleAssignmentsByCriteriaQuery_spaceRoleAssignmentsByCriteria;
}

export interface SpaceRoleAssignmentsByCriteriaQueryVariables {
  spaceId: any;
  principalTypes?: (PrincipalFilterType | null)[] | null;
  spaceRoleIds?: (string | null)[] | null;
  filterOutGroupTypes?: (ConfluenceGroupUsageType | null)[] | null;
  first?: number | null;
  after?: string | null;
}
